import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import {Checkbox} from "primereact/checkbox";
import ContextMenu from "../../../components/contextMenu";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const DailyLoansView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <HeaderScreenPresval headerTitle="Reportes \ Préstamos del Día"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getDataDailyReport}
                                             buttonName={"Parámetros"}
                                             disabledSearchButton = {props.disabledSearchButton}>
                            <div className="p-grid">
                                <div className="p-col-4">
                                    <SubtitleLabel header="Mostrar sección" isBold={true}/>
                                </div>
                                <div className="p-col-8">
                                    <SubtitleLabel header="Mostrar columna" isBold={true}/>
                                </div>
                                <div className="p-col-2">
                                    <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                                className={"secondary-text"}>
                                        <Checkbox
                                            name="guaranteeCheck"
                                            checked={props.filters.guaranteeCheck}
                                            onChange={props.onFiltersChange}/>
                                        &nbsp;
                                        Garantías
                                    </Typography>
                                </div>
                                <div className="p-col-2">
                                    <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                                className={"secondary-text"}>
                                        <Checkbox
                                            name="dateCheck"
                                            checked={props.filters.dateCheck}
                                            onChange={props.onFiltersChange}/>
                                        &nbsp;
                                        Fecha valor
                                    </Typography>
                                </div>

                                <div className="p-col-2">
                                    <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                                className={"secondary-text"}>
                                        <Checkbox name="accountColumn"
                                                  checked={props.columnSelected.accountColumn}
                                                  onChange={props.onColumnToggle}/>
                                        &nbsp; Cuenta
                                    </Typography>
                                </div>
                                <div className="p-col-2">
                                    <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                                className={"secondary-text"}>
                                        <Checkbox name="commissionColumn"
                                                  checked={props.columnSelected.commissionColumn}
                                                  onChange={props.onColumnToggle}/>
                                        &nbsp; Comisión
                                    </Typography>
                                </div>

                                <div className="p-col-4">
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-12" style={{textAlign: 'right'}}>
                                <ContextMenu menuOptions={props.exportOptions}
                                             isButton={true}
                                             label="Exportar"/>
                            </div>
                        </div>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            value={props.dataDailyReport}
                            scrollable={true}
                            expandedRows={props.expandedRows}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            style={{width: '100%'}}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                            scrollHeight="600px">
                            {props.columns}
                        </DataTable>
                    </Grid>
                    {props.confMsg}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default DailyLoansView;